var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.724,
    height: 40.724,
    viewBox: "0 0 40.724 40.724",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1424",
    "data-name": "Group 1424",
    transform: "translate(-935 -485.853)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    cx: 20.362,
    cy: 20.362,
    r: 20.362,
    transform: "translate(935 485.853)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-power",
    "data-name": "Icon metro-power",
    d: "M9.114,1.928,2.571,13.582H9.114L4.752,25.236,20.019,10.669H11.295l6.543-8.74Z",
    transform: "translate(944.85 493.416)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower);
export default __webpack_public_path__ + "static/media/power.8e03f9cb62b2c6d9acbd53f1016b7835.svg";
export { ForwardRef as ReactComponent };